import { Theme } from '@gpthouse/schemas';
import { useContext } from 'react';

import PageContext from '@/Providers/PageContextProvider/PageContext';
import LogtoLogtoDark from '@/assets/icons/logo-dark.svg?react';
import LogtoLogoLight from '@/assets/icons/logo-light.svg?react';
import LogtoLogoShadow from '@/assets/icons/logo-shadow.svg?react';

import styles from './index.module.scss';

const logtoUrl = `https://gpthouse.ai/?${new URLSearchParams({
  utm_source: 'sign_in',
  utm_medium: 'powered_by',
}).toString()}`;

type Props = {
  readonly className?: string;
};

const LogtoSignature = ({ className }: Props) => {
  const { theme } = useContext(PageContext);
  const LogtoLogo = theme === Theme.Light ? LogtoLogoLight : LogtoLogtoDark;

  return (
    <div className={className}>
      <a
        className={styles.signature}
        aria-label="Powered By Logto"
        href={logtoUrl.toString()}
        target="_blank"
        rel="noopener"
      >
        <span className={styles.text}>Powered by</span>
        <LogtoLogoShadow className={styles.staticIcon} style={{ width: 30 }} />
        <LogtoLogo className={styles.highlightIcon} style={{ width: 30, borderRadius: '80%' }} />
      </a>
    </div>
  );
};

export default LogtoSignature;
